import { Chip } from '@mui/material'

const statusColors = {
  // Work Order statuses
  open: { bg: '#dbeafe', text: '#1e40af' },
  assigned: { bg: '#fef3c7', text: '#92400e' },
  in_progress: { bg: '#e0e7ff', text: '#3730a3' },
  on_hold: { bg: '#fecaca', text: '#991b1b' },
  completed: { bg: '#d1fae5', text: '#065f46' },
  closed: { bg: '#e5e7eb', text: '#374151' },
  cancelled: { bg: '#fecaca', text: '#991b1b' },

  // Asset statuses (A-F classification)
  a: { bg: '#d1fae5', text: '#065f46', label: 'A − Good and in use' },
  b: { bg: '#dbeafe', text: '#1e40af', label: 'B − Good but not in use' },
  c: { bg: '#fef3c7', text: '#92400e', label: 'C − In use but needs repair' },
  d: { bg: '#fef3c7', text: '#92400e', label: 'D − In use but needs maintenance' },
  e: { bg: '#fed7aa', text: '#9a3412', label: 'E − Not in use, needs repair/maintenance' },
  f: { bg: '#fecaca', text: '#991b1b', label: 'F − Not functional, needs discard' },
  // Legacy asset statuses (for backward compatibility)
  operational: { bg: '#d1fae5', text: '#065f46' },
  maintenance: { bg: '#fef3c7', text: '#92400e' },
  under_maintenance: { bg: '#fef3c7', text: '#92400e' },
  out_of_service: { bg: '#fecaca', text: '#991b1b' },
  out_for_repair: { bg: '#e0e7ff', text: '#3730a3' },
  condemned: { bg: '#374151', text: '#ffffff' },
  disposed: { bg: '#e5e7eb', text: '#374151' },
  retired: { bg: '#e5e7eb', text: '#374151' },

  // Transfer statuses
  requested: { bg: '#fef3c7', text: '#92400e' },
  in_transit: { bg: '#dbeafe', text: '#1e40af' },

  // Requisition statuses
  draft: { bg: '#e5e7eb', text: '#374151' },
  submitted: { bg: '#fef3c7', text: '#92400e' },
  under_review: { bg: '#e0e7ff', text: '#3730a3' },
  ordered: { bg: '#dbeafe', text: '#1e40af' },
  received: { bg: '#d1fae5', text: '#065f46' },

  // PM Schedule / External Repair statuses
  scheduled: { bg: '#dbeafe', text: '#1e40af' },
  overdue: { bg: '#fecaca', text: '#991b1b' },
  skipped: { bg: '#e5e7eb', text: '#374151' },
  sent_out: { bg: '#fef3c7', text: '#92400e' },
  in_repair: { bg: '#e0e7ff', text: '#3730a3' },
  ready_pickup: { bg: '#dbeafe', text: '#1e40af' },
  returned: { bg: '#d1fae5', text: '#065f46' },

  // Vehicle statuses
  available: { bg: '#d1fae5', text: '#065f46' },
  in_use: { bg: '#dbeafe', text: '#1e40af' },

  // Priority
  low: { bg: '#e5e7eb', text: '#374151' },
  medium: { bg: '#dbeafe', text: '#1e40af' },
  high: { bg: '#fef3c7', text: '#92400e' },
  critical: { bg: '#fecaca', text: '#991b1b' },
  urgent: { bg: '#fecaca', text: '#991b1b' },

  // General
  active: { bg: '#d1fae5', text: '#065f46' },
  inactive: { bg: '#e5e7eb', text: '#374151' },
  pending: { bg: '#fef3c7', text: '#92400e' },
  approved: { bg: '#d1fae5', text: '#065f46' },
  rejected: { bg: '#fecaca', text: '#991b1b' },

  // Default
  default: { bg: '#e5e7eb', text: '#374151' },
}

const StatusChip = ({ status, label, size = 'small', ...props }) => {
  const normalizedStatus = status?.toLowerCase().replace(/\s+/g, '_') || 'default'
  const statusConfig = statusColors[normalizedStatus] || statusColors.default
  const colors = { bg: statusConfig.bg, text: statusConfig.text }
  const displayLabel = label || statusConfig.label || status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())

  return (
    <Chip
      label={displayLabel}
      size={size}
      sx={{
        backgroundColor: colors.bg,
        color: colors.text,
        fontWeight: 500,
        textTransform: 'capitalize',
      }}
      {...props}
    />
  )
}

export default StatusChip
